
/**
 * Format a number as a currency value
 * @param value The number to format
 * @param digits The number of decimal places to show (default: 2)
 * @returns Formatted currency string without the currency symbol
 */
export const formatCurrency = (value: number, digits: number = 2): string => {
  return value.toFixed(digits);
};

/**
 * Format a date to a readable string
 * @param date The date to format
 * @param format The format to use (default: 'medium')
 * @returns Formatted date string
 */
export const formatDate = (date: Date | string, format: 'short' | 'medium' | 'long' = 'medium'): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  
  const options: Intl.DateTimeFormatOptions = { 
    year: 'numeric', 
    month: format === 'short' ? 'short' : 'long', 
    day: 'numeric'
  };
  
  if (format === 'long') {
    options.hour = '2-digit';
    options.minute = '2-digit';
  }
  
  return dateObj.toLocaleDateString('en-US', options);
};
